export const getLanguage = (locale) => locale.slice(0, 2);
